import React from 'react';
import ReactDOM from 'react-dom';

import TextBlock from '../../blocks/textblock';
import CountyContentAreaBlock from '../../blocks/countycontentareablock';
import MenuBlock from '../../blocks/menublock';
import DynamicFeatureBlock from '../../blocks/dynamicfeatureblock';
import DualTextBlock from '../../blocks/dualtextblock';
import RelatedMaterialBlock from '../../blocks/relatedmaterialblock';
import CollapsibleBlock from '../../blocks/collapsibleblock';
import CollapsibleContainerBlock from '../../blocks/collapsiblecontainerblock';
import CardCarouselBlock from '../../blocks/cardcarouselblock';
import CardCarouselBlockItem from '../../blocks/cardcarouselblockitem';
import CarouselBlock from '../../blocks/carouselblock';
import ParallaxBlock from '../../blocks/parallaxblock';

export const blockRegistry = {
  TextBlock,
  CountyContentAreaBlock,
  MenuBlock,
  DynamicFeatureListBlock: DynamicFeatureBlock,
  DualTextBlock,
  RelatedMaterialBlock,
  CollapsibleBlock,
  CollapsibleContainerBlock,
  CardCarouselBlock,
  CardCarouselBlockItem,
  CarouselBlock,
  ParallaxBlock
};
